import { PageLayout } from '../components/PageLayout'

export function ExclusaoDeDados() {
  return (
    <PageLayout title="Exclusão de Dados" lastUpdated="17 de Maio de 2026">
      <section>
        <h2>1. Como solicitar exclusão</h2>
        <p>
          Usuários, pacientes ou responsáveis legais podem solicitar a exclusão, anonimização
          ou bloqueio de dados pessoais tratados pelo SecBrain, conforme a Lei Geral de
          Proteção de Dados (LGPD).
        </p>
        <p>
          Para solicitar a exclusão, envie um e-mail para{' '}
          <a href="mailto:info@secbra.in">info@secbra.in</a> com o assunto
          "Solicitação de exclusão de dados" e informe:
        </p>
        <ul>
          <li>Nome completo do titular dos dados</li>
          <li>E-mail ou telefone usado na plataforma</li>
          <li>Nome da clínica ou organização vinculada, quando aplicável</li>
          <li>Descrição dos dados que deseja excluir</li>
          <li>Documento ou informação necessária para confirmação de identidade</li>
        </ul>
      </section>

      <section>
        <h2>2. Prazo de resposta</h2>
        <p>
          Responderemos a solicitação em até 15 dias, conforme previsto na LGPD. Em alguns
          casos, poderemos pedir informações adicionais para confirmar a identidade do
          solicitante ou a relação com o titular dos dados.
        </p>
      </section>

      <section>
        <h2>3. Dados que podem ser mantidos</h2>
        <p>
          Alguns dados podem ser mantidos quando houver obrigação legal, regulatória,
          contratual, necessidade de auditoria, segurança, prevenção a fraudes ou defesa em
          processos administrativos, judiciais ou arbitrais.
        </p>
        <p>
          Dados de pacientes e registros relacionados a cuidados de saúde podem ter prazos
          específicos de retenção conforme a legislação e as normas profissionais aplicáveis.
        </p>
      </section>

      <section>
        <h2>4. Revogação de comunicações por WhatsApp</h2>
        <p>
          Para deixar de receber comunicações pelo WhatsApp, o titular ou responsável também
          pode responder <strong>SAIR</strong> diretamente na conversa com o SecBrain.
        </p>
      </section>

      <section>
        <h2>5. Contato do encarregado</h2>
        <p>
          Encarregado de Proteção de Dados (DPO):{' '}
          <a href="mailto:info@secbra.in">info@secbra.in</a>
        </p>
        <p>
          Secbrain Inteligencia Artificial Tecnologia LTDA<br />
          CNPJ: 52.234.008/0001-16<br />
          Avenida Júlia Freire, 1200, Sala 109/110/111/112, Expedicionários,
          João Pessoa - PB, CEP 58041-000
        </p>
      </section>
    </PageLayout>
  )
}
